"use strict";

/*
 ## External Dependencies ##
 - jQuery ($)
 */

var Reflux = require("reflux");
var config = require("app/util/config/config");
var _ = require("underscore");
var cx = require("classnames");
var EntitySuggestionsActions = require("app/shared/actions/entity-suggestions-actions");
var EntitySuggestionsStore = require("app/shared/stores/entity-suggestions-store");
var KeyNavigatorMixin = require("app/util/browser/key-navigator").mixin;
var MultiActionStore = require("app/util/flux/multi-action-store");
var textFormatter = require("app/util/formatter/text");
var UserAvatar = require("app/shared/components/User/user-avatar");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Icon = require("app/shared/components/Icon/icon");

var entityIcons = {
  "Empresa": "icon-organization",
  "Pessoa": "icon-person",
  "Negocio": "icon-deal"
};

var EntitySuggestions = React.createClass({
  mixins: [Reflux.ListenerMixin, MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      entitySuggestionsStore: EntitySuggestionsStore,
      entitySuggestionsActions: EntitySuggestionsActions
    };
  },
  getDefaultProps: function() {
    return ({
      onSelect: null,
      afterSelect: null,
      afterClear: null,
      allowedTypes: ["organization", "person", "deal"],
      qpp: 5,
      value: null,
      placeholder: "Em qual empresa, pessoa ou negócio?",
      allowCreate: true,
      showCategory: false,
      showAvatar: false,
      showSearchIcon: false,
      pagination: false,
      addBorders: false,
      selectable: true
    });
  },
  getInitialState: function () {
    var storeState = this.entitySuggestionsStore.state;

    storeState.instanceKey = this.props.instanceKey;
    storeState.onSelect = this.props.onSelect;
    storeState.afterSelect = this.props.afterSelect;
    storeState.afterClear = this.props.afterClear;
    storeState.pagination = this.props.pagination;
    storeState.selectable = this.props.selectable;

    if (this.props.value) {
      var entity = { nome: this.props.value };

      storeState.entity = entity;
      storeState.selectedItem = entity;
    }

    return storeState;
  },
  componentDidMount: function () {
    this.listenTo(this.entitySuggestionsStore, this.setState);
  },
  componentWillUpdate: function(nextProps, nextState) {
    if (nextState.createdEntity) {
      this.entitySuggestionsActions.selectSuggestion(nextState.createdEntity);
    }
  },
  onFocus: function() {
    $(document)
      .off("click", this.handleMouseClick)
      .on("click", this.handleMouseClick);
  },
  componentWillUnmount: function () {
    $(document).off("click", this.handleMouseClick);
  },
  handleMouseClick: function(event){
    if(!$(this.refs.wrapper).is(":hover")) {
      $(document).off("click", this.handleMouseClick);
      this.hideSuggestions();
    }
  },
  hideSuggestions: function() {
    this.entitySuggestionsActions.hideSuggestions();
  },
  focusInput: function() {
    this.refs.input.focus();
  },
  hasNextPage: function() {
    return (
      this.props.pagination
        && this.state.suggestions.length < this.state.total
        && !this.state.emptyPage
    );
  },
  onGetNextPage: function() {
    this.entitySuggestionsActions.showSuggestions({
      text: this.state.searchText,
      qpp: this.props.qpp,
      allowedTypes: this.props.allowedTypes,
      page: (this.state.page + 1)
    });
  },
  render: function () {
    return (
      <div ref="wrapper" onFocus={this.onFocus} className="entitySuggestion">
        <EntityInput
          {...this.state}
          allowedTypes={this.props.allowedTypes}
          qpp={this.props.qpp}
          placeholder={this.props.placeholder}
          showSearchIcon={this.props.showSearchIcon}
          ref="input"
        />
        <EntitySuggestionsList
          {...this.state}
          allowedTypes={this.props.allowedTypes}
          allowCreate={this.props.allowCreate}
          showCategory={this.props.showCategory}
          showAvatar={this.props.showAvatar}
          hasNextPage={this.hasNextPage()}
          onGetNextPage={this.onGetNextPage}
          addBorders={this.props.addBorders}
          selectable={this.props.selectable}
        />
      </div>
    );
  }
});

var EntityInput = React.createClass({
  mixins: [KeyNavigatorMixin, MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      entitySuggestionsActions: EntitySuggestionsActions,
    };
  },
  getInitialState: function(){
    return {
      searchText: this.props.searchText
    };
  },
  componentWillReceiveProps: function(props){
    var state = {
      searchText: props.searchText
    };
    this.setState(state);
  },
  focus: function() {
    this.refs.input.focus();
  },
  onChange: function (event) {
    var typedValue = event.target.value;
    this.setState({ searchText: typedValue }); // Needed to prevent text cursor from jumping

    if(!typedValue || typedValue.length < 2) {
      this.entitySuggestionsActions.hideSuggestions(typedValue);
    } else {
      this.entitySuggestionsActions.showSuggestions({
        text: typedValue,
        qpp: this.props.qpp,
        allowedTypes: this.props.allowedTypes,
        page: 0
      });
    }
  },
  getText: function () {
    if (this.props.selectedItem) {
      return this.props.selectedItem.nome;
    } else {
      return this.state.searchText;
    }
  },
  keyNavigate: function(keyCode){
    this.entitySuggestionsActions.keyNavigate(keyCode);
  },
  readonly: function () {
    var otherAttributes = {};
    if (this.props.selectedItem != null) {
      otherAttributes.readOnly = "readonly";
    }
    return otherAttributes;
  },
  render: function () {
    return (
      <div className="w-100pct">
        <input
          type="text"
          className="entitySuggestion-input form-control"
          autoComplete="off"
          spellCheck="false"
          onChange={this.onChange}
          placeholder={this.props.placeholder}
          value={this.getText()}
          {...this.readonly()}
          onKeyDown={this.onKeyDown}
          ref="input"
        />
        <EntityInputButton {...this.props} text={this.getText()} />
      </div>
    );
  }
});

var EntityInputButton = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      entitySuggestionsActions: EntitySuggestionsActions,
    };
  },
  onClick: function () {
    this.entitySuggestionsActions.clearSelected();
  },
  render: function () {
    if (this.props.selectedItem || this.props.showSearchIcon && this.props.text) {
      return (
        <div className="entitySuggestion-searchClear">
          <button className="entitySuggestion-searchClearLink" type="button" onClick={this.onClick}>
            <Icon custom icon="close" />
          </button>
        </div>
      );
    } else if (this.props.showSearchIcon) {
      return (
        <div className="entitySuggestion-searchClear">
          <Icon custom icon="search" className="text-primary" />
        </div>
      );
    } else {
      return null;
    }
  }
});

var EntitySuggestionsList = React.createClass({
  getListContent: function() {
    var list = [];
    var suggestions = this.props.suggestions || {};

    if (suggestions.length > 0) {
      list = suggestions.map(function (entity, index) {
        var isFocused = (this.props.focusIndex == index);
        var props = {
          instanceKey: this.props.instanceKey,
          entity: entity,
          searchText: this.props.searchText,
          key: entity.obj + entity.id,
          isFocused: isFocused,
          index: index,
          showCategory: this.props.showCategory,
          showAvatar: this.props.showAvatar,
          addBorders: this.props.addBorders,
          selectable: this.props.selectable
        };
        return <EntitySuggestionsListItem {...props} />;
      }, this);
    }

    let message = null;
    let messageClass = null;
    if (this.props.errorMsg) {
      message = this.props.errorMsg;
      messageClass = "warning";
    } else if (this.props.loading) {
      message =
        <span>
          <img src="/skins/imagens/loaders/ajax-loader-azul.gif" className="pr-15"/>
          Buscando...
        </span>;
    } else if (suggestions.length === 0) {
      message = "Nenhum resultado encontrado";
    } else if (this.props.hasNextPage) {
      message =
        <a href="javascript:void(0)" onClick={this.props.onGetNextPage}>
          <Icon custom icon="chevron-down" className="p-5 va-mid" />
          <span className="va-mid ml-15">Ver mais resultados</span>
        </a>;
    }

    if (message) {
      let messageClasses = cx(
        "entitySuggestion-listItem",
        "entitySuggestion-statusMsg",
        messageClass
      );

      list.push(
        <li key="statusMsg" className={messageClasses}>
          {message}
        </li>
      );
    }

    return list;
  },
  renderAddGroup: function() {
    if (this.props.allowCreate && this.props.selectable) {
      return <EntitySuggestionsAddGroup {...this.props} />;
    }
  },
  render: function () {
    var classes = cx(
      "entitySuggestion-list",
      "mah-640",
      "ovy-auto",
      { "d-b": this.props.expandSuggestions }
    );
    return (
      <ul className={classes}>
        {this.getListContent()}
        {this.renderAddGroup()}
      </ul>
    );
  }
});

var EntitySuggestionsAddGroup = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      entitySuggestionsActions: EntitySuggestionsActions,
    };
  },
  addOrganization: function(){
    this.entitySuggestionsActions.addOrganization({ name: this.props.searchText });
  },
  addPerson: function(){
    this.entitySuggestionsActions.addPerson({ name: this.props.searchText });
  },
  addDeal: function(){
    this.entitySuggestionsActions.addDeal({ title: this.props.searchText });
  },
  onClickForType: function(type) {
    switch (type) {
      case "organization":
        return this.addOrganization;

      case "person":
        return this.addPerson;

      case "deal":
        return this.addDeal;
    }
  },
  labelForType: function(type) {
    switch (type) {
      case "organization":
        return "Empresa";

      case "person":
        return "Pessoa";

      case "deal":
        return "Negócio";
    }
  },
  render: function() {
    let text;
    let wrapperClasses = cx("entitySuggestion-addButtonWrapper", { disabled: this.props.adding })

    if(this.props.adding) {
      text = "Adicionando...";
    } else {
      text = `Adicionar "${this.props.searchText}" como`;
    }

    return (
      <li className="entitySuggestion-listItem entitySuggestion-addButtons">
        <span className="fs-12 c-999 d-b ta-c mt-10">{text}</span>
        <table className="w-100">
          <tbody>
            <tr>
              {this.props.allowedTypes.map(type => (
                <td key={type}>
                  <span className={wrapperClasses}>
                    <a className="entitySuggestion-addButton" href="javascript:void(0);" onClick={this.onClickForType(type)}>
                      + <Icon custom icon={type} />
                      <span className="entitySuggestion-addButtonLabel">{this.labelForType(type)}</span>
                    </a>
                  </span>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </li>
    );
  }
});

var EntitySuggestionsListItem = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      entitySuggestionsActions: EntitySuggestionsActions,
    };
  },
  componentDidUpdate: function(prevProps) {
    if (!this.props.isFocused) {
      this.refs.tooltip.hide();
    } else if (!prevProps.isFocused) {
      this.refs.tooltip.show();
    }
  },
  componentWillUnmount: function() {
    this.refs.tooltip.hide();
  },
  onMouseOver: function() {
    // we are not using hover anymore because we need to know which element is focused so the keys shortcuts can work
    this.entitySuggestionsActions.focusItem(this.props.index);
  },
  onClick: function(event) {
    event.preventDefault();
    this.entitySuggestionsActions.selectSuggestion(this.props.entity);
  },
  isAllowed: function() {
    return this.props.entity.allowed !== false;
  },
  tooltipLabel: function() {
    if (this.isAllowed())
      return;

    var complement = "Esse registro";

    switch (this.props.entity.obj) {
      case "Empresa":
        complement = "Essa empresa";
        break;

      case "Pessoa":
        complement = "Essa pessoa";
        break;

      case "Negocio":
        complement = "Esse negócio";
        break;
    }

    return (
      "<h6>" + complement + " possui privacidade fechada</h6>" +
      "<p>Isso significa que apenas os responsáveis por esse cliente podem " +
      "acessar seus dados.</p>" +
      "<p>Para obter acesso, solicite ao seu gestor.</p>"
    );
  },
  highlight: function(string) {
    let term = this.props.searchText.toLowerCase();
    let startIndex = string.toLowerCase().indexOf(term);

    if (startIndex !== -1) {
      let endIndex = startIndex + term.length;

      return (
        <span>
          {string.substring(0, startIndex)}
          <strong>{string.substring(startIndex, endIndex)}</strong>
          {string.substring(endIndex)}
        </span>
      )
    } else {
      return <span>{string}</span>;
    }
  },
  getHref: function() {
    if (!this.isAllowed()) {
      return null;
    }

    let typeSegment = this.props.entity.obj.toLowerCase() + "s";

    return `/sistema/${typeSegment}/historico.php?id=${this.props.entity.id}`;
  },
  getOnClick: function() {
    if (!this.isAllowed() || !this.props.selectable) {
      return null;
    }

    return this.onClick;
  },
  renderRelated: function() {
    let content = null;

    if (this.props.entity.ligacao) {
      content = this.highlight(this.props.entity.ligacao);
    } else if (this.props.showCategory) {
      content = this.props.entity.categoria;
    }

    if (!content)
      return;

    return (
      <div className="fs-12 c-999">
        <Icon custom icon="link" className="fs-12 mr-3 va-mid" />
        <span className="va-mid">{content}</span>
      </div>
    );
  },
  renderLock: function() {
    if (this.isAllowed())
      return;

    return (
      <span className="entitySuggestion-itemPermission">
        <Icon custom icon="lock-circle" className="entitySuggestion-lockIcon" />
      </span>
    );
  },
  renderAvatar: function() {
    if (!this.props.showAvatar || !this.props.entity.owner_user_name)
      return;

    return (
      <UserAvatar
        size="small"
        url={this.props.entity.owner_user_small_avatar}
        name={this.props.entity.owner_user_name}
      />
    );
  },
  render: function() {
    var key = (this.props.entity.obj + "-" + this.props.entity.id);
    var notAllowed = !this.isAllowed();

    var linkClasses = cx(
      "entitySuggestion-listItem",
      "entitySuggestion-item", {
      isFocused: this.props.isFocused,
      "pr-64": notAllowed,
      "muted": notAllowed,
      "bb-light": this.props.addBorders
    });

    var iconClasses = cx(
      entityIcons[this.props.entity.obj],
      "entitySuggestion-itemIcon",
      "custom-glyphicon",
      "p-r"
    );

    var imgClasses = cx("entitySuggestion-itemImg");
    var nameClasses = cx("entitySuggestion-itemName");
    var descClasses = cx("entitySuggestion-itemDesc");

    return (
      <li>
        <Tooltip right html block
          title={this.tooltipLabel()}
          container="body"
          ref="tooltip"
        >
          <a
            className={linkClasses}
            href={this.getHref()}
            key={key}
            onClick={this.getOnClick()}
            onMouseOver={this.onMouseOver}
          >
            <div className={iconClasses}>
              {this.renderLock()}
            </div>

            <div className={nameClasses}>
              <div>{this.highlight(this.props.entity.nome)}</div>

              {this.renderRelated()}
            </div>

            {this.renderAvatar()}
          </a>
        </Tooltip>
      </li>
    );
  }
});

module.exports = EntitySuggestions;



// WEBPACK FOOTER //
// ./app/shared/components/EntitySuggestions/entity-suggestions.jsx